import { HttpClient } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { Http } from '@angular/http';

@Component({
  selector: 'hospital-booking-header',
  template: require('./header.component.html'),
  styles: [require('./header.component.scss')],
})
export class HeaderComponent {
  public logoURL: string;

  constructor(
    @Inject('$location') public $location,
    @Inject('$state') public $state,
  ) {}

  ngOnInit() {
    this.logoURL = this.$location.$$search.logo_path;
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/hospital-booking/header/header.component.ts